<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <state-form></state-form>
      </div>
    </div>
  </div>
</template>

<script>
import StateForm from "@/views/state/components/Form.vue";

export default {
  name: "add-state",
  components: {
    StateForm,
  }
};
</script>